import texts from './copywriting.json'
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

// export function getSitesEditorModuleStateKey(prefix, moduleProp) {
//   return `${prefix}_${moduleProp.type}_${moduleProp._id}`
// }
export function getObjId(prefix, id, userid) {
  return `${prefix}_${id}_${userid}`
}
export function getSitesEditorModuleStateKey(prefix, moduleProp) {
  return `${prefix}_${moduleProp.itemType}_${moduleProp.id}`
}

export function mapObj(theMap, data, isRevert = false) {
  const newData = {}
  if (isRevert) {
    for (const key in data) {
      newData[theMap[key]] = data[key]
    }
  } else {
    for (const key in theMap) {
      newData[key] = data[theMap[key]]
    }
  }
  return newData
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () { }
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = s => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function converBToMb(fileSize) {
  let size = ''
  if (fileSize < 0.1 * 1024) {
    size = fileSize.toFixed(2) + 'B'
  } else if (fileSize < 0.1 * 1024 * 1024) {
    size = (fileSize / 1024).toFixed(2) + 'KB'
  } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
    size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  const sizestr = size + ''
  const len = sizestr.indexOf('.')
  const dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export function transformUrl(url) {
  if (url) {
    if (Array.isArray(url)) {
      for (const item of url) {
        if (item.bannerUrl) {
          if (item.bannerUrl.startsWith('http')) {
            return item.bannerUrl
          }
          if (!item.bannerUrl.startsWith('/')) {
            item.bannerUrl = '/' + item.bannerUrl
          }
          return process.env.VUE_APP_OBS_URL + process.env.VUE_APP_OBS_FOLDER_NAME + item.bannerUrl
        }
      }
    }
    if (url.startsWith('http')) {
      return url
    }
    if (!url.startsWith('/')) {
      url = '/' + url
    }
    return process.env.VUE_APP_OBS_URL + process.env.VUE_APP_OBS_FOLDER_NAME + url
  }
}
// 链接地址判断，是否含有http或者https
export function checkUrl(url) {
  if (url) {
    // 判断是否符合http://符合返回真不符合返回假
    const http = /^http:\/\/.*/i.test(url)
    // 判断是否符合https://符合返回真不符合返回假
    const https = /^https:\/\/.*/i.test(url)
    // 如果两个都为假，我们就为客户添加http://
    if (!http && !https) {
      url = 'http://' + url
    } else {
      return true
    }
    return url
  }
}
// 如果要确保函数只执行一次的情况
export function onceEvent(fn) {
  let called = false
  return function () {
    if (!called) {
      called = true
      fn.apply(this, arguments)
    }
  }
}

export function domainUrlTransForm(url) {
  const domain51lss = '51lss.com'
  const domainKuaijisishu = 'kuaijisishu.com'
  if (window.location.href.indexOf(domainKuaijisishu) > -1) {
    return url.replace(domain51lss, domainKuaijisishu)
  }
  return url
}

export function isJson($string) {
  try {
    if (typeof JSON.parse($string) === 'object') {
      return true
    }
    return false
  } catch (e) {
    console.log(e)
    return false
  }
}

export const replaceRegExp = (text, badword) => {
  let value = text
  let res = ''
  // 遍历敏感词数组
  for (let i = 0; i < badword.length; i++) {
    const keyword = badword[i]
    const reg = new RegExp(keyword, 'g')
    // 判断内容中是否包括敏感词
    // if (reg.test(value)) {
    // 将敏感词替换为 *
    res = value.replace(reg, function (word) {
      let str = ''
      for (let i = 0; i < word.length; i++) {
        str += '*'
      };
      return str
    })
    value = res
    // }
  }
  return value
}

// 手机号隐藏
export const handlePhone = (phone) => {
  return phone.replace(/(?<=\d{3})\d{4}/, '****')
}
// 获取随机文本
export const randomText = () => {
  const num = Math.floor(Math.random() * texts.length)
  return texts[num]
}
